export default __webpack_public_path__ + "static/media/GPA_Banner_Power_to_Serve.abdd7241.jpg";